import { useEffect } from 'react';
import { otpValidationSchema } from '../components/Form/validationSchema.js';

const useAutoSubmitForm = (props) => {
    const { enabled = true, formRef, methods } = props;
    const { watch } = methods;
    useEffect(() => {
        if (!enabled)
            return;
        const subscription = watch((data, { name }) => {
            if (name !== "code" /* FIELD_NAME.OTP */)
                return;
            const isValid = otpValidationSchema.isValidSync(data);
            if (!isValid || formRef.current === null)
                return;
            formRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
        return () => subscription.unsubscribe();
    }, [enabled, formRef, watch]);
};

export { useAutoSubmitForm };
//# sourceMappingURL=useAutoSubmitForm.js.map
